
export default function Services() {
  const services = [
    {
      icon: 'ri-car-line',
      title: 'Vehicle Window Tinting',
      description: 'Professional automotive window tinting with premium films for UV protection, privacy, and style.',
      features: ['UV Protection', 'Heat Reduction', 'Privacy Enhancement', 'Glare Reduction'],
      image: 'https://static.readdy.ai/image/c209f1799ad125177e0fe6e14cfcc3f4/1afc1306b188a2c81a8e5255dfc1d96a.jpeg'
    },
    {
      icon: 'ri-palette-line',
      title: 'Custom Vehicle Wraps',
      description: 'Transform your vehicle with stunning custom wraps and graphics that make a lasting impression.',
      features: ['Custom Design', 'Premium Materials', 'Full/Partial Wraps', 'Paint Protection'],
      image: 'https://static.readdy.ai/image/c209f1799ad125177e0fe6e14cfcc3f4/5f645480ea7726295691e02843677d64.png'
    },
    {
      icon: 'ri-home-4-line',
      title: 'Residential Window Tinting',
      description: 'Enhance your home\'s comfort and energy efficiency with professional residential window films.',
      features: ['Energy Savings', 'UV Protection', 'Privacy Control', 'Decorative Options'],
      image: 'https://public.readdy.ai/ai/img_res/82dcdcb96b090799caafff56a98db8f8.jpg'
    },
    {
      icon: 'ri-truck-line',
      title: 'Commercial Vehicle Wraps',
      description: 'Boost your business visibility with professional fleet branding and commercial vehicle graphics.',
      features: ['Fleet Branding', 'Mobile Advertising', 'Consistent Design', 'Durable Materials'],
      image: 'https://static.readdy.ai/image/c209f1799ad125177e0fe6e14cfcc3f4/597f47a7eaeb7e9a1787ef7825784d7e.png'
    },
    {
      icon: 'ri-pencil-ruler-2-line',
      title: 'Brand Identity Design',
      description: 'Complete brand identity solutions from logo design to comprehensive brand implementation.',
      features: ['Logo Design', 'Brand Guidelines', 'Marketing Materials', 'Digital Assets'],
      image: 'https://readdy.ai/api/search-image?query=Professional%20brand%20identity%20design%20workspace%20with%20creative%20branding%20materials%2C%20logo%20designs%2C%20brand%20guidelines%2C%20marketing%20collateral%2C%20modern%20graphic%20design%20studio%20with%20professional%20equipment%20and%20creative%20atmosphere&width=400&height=300&seq=service005&orientation=landscape'
    },
    {
      icon: 'ri-store-2-line',
      title: 'Commercial Signage',
      description: 'Complete signage solutions including storefront graphics, interior signs, and digital displays.',
      features: ['Storefront Graphics', 'Interior Signage', 'Digital Displays', 'Wayfinding Systems'],
      image: 'https://readdy.ai/api/search-image?query=Professional%20commercial%20signage%20installation%20on%20modern%20business%20storefront%20with%20illuminated%20signs%2C%20interior%20and%20exterior%20business%20signage%2C%20professional%20sign%20installation%20service%2C%20modern%20commercial%20building%20with%20attractive%20signage&width=400&height=300&seq=service006&orientation=landscape'
    }
  ];

  return (
    <section id="services" className="py-20 bg-gray-800">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Our Professional Services
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            From individual vehicle customization to comprehensive commercial branding solutions, 
            we deliver exceptional quality and service for every project.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div key={index} className="bg-gray-900 rounded-xl overflow-hidden shadow-xl hover:shadow-2xl transition-all duration-300 border border-gray-700 hover:border-blue-500/50">
              <div className="relative h-48 overflow-hidden">
                <img 
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-gray-900/80 to-transparent"></div>
              </div>
              
              <div className="p-6">
                <div className="w-12 h-12 flex items-center justify-center bg-blue-600 rounded-lg mb-4 text-white">
                  <i className={`${service.icon} text-2xl`}></i>
                </div>
                
                <h3 className="text-xl font-semibold text-white mb-3">{service.title}</h3>
                <p className="text-gray-300 mb-4 leading-relaxed">{service.description}</p>
                
                <div className="space-y-2">
                  {service.features.map((feature, idx) => (
                    <div key={idx} className="flex items-center text-sm text-gray-400">
                      <div className="w-4 h-4 flex items-center justify-center mr-3 text-blue-400">
                        <i className="ri-check-line text-sm"></i>
                      </div>
                      {feature}
                    </div>
                  ))}
                </div>
                
                <button className="mt-6 w-full bg-blue-600 text-white py-3 rounded-lg hover:bg-blue-700 transition-colors cursor-pointer whitespace-nowrap font-medium">
                  Learn More
                </button>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <button className="bg-blue-600 text-white px-8 py-4 text-lg font-semibold rounded-lg hover:bg-blue-700 transition-colors cursor-pointer whitespace-nowrap shadow-lg">
            Get Custom Quote for Your Project
          </button>
        </div>
      </div>
    </section>
  );
}
